import Widget from './Widget'
import styles from './WidgetImage.module.css'

interface WidgetImageProps {
  src: string
  alt: string
  size?: 'small' | 'medium' | 'large'
  backgroundColor?: string
}

export default function WidgetImage({ src, alt, size = 'medium', backgroundColor }: WidgetImageProps) {
  return (
    <Widget size={size} rounded backgroundColor={backgroundColor}>
      <img src={src} alt={alt} className={styles.image} />
    </Widget>
  )
}
